import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const variationKeys = {
  all: ['variation'] as const,
  details: () => [...variationKeys.all, 'detail'] as const,
  detail: (variationId: string, isAuthenticated: boolean) =>
    [...variationKeys.details(), { variationId, isAuthenticated }] as const,
};

export function useVariation(variationId: string | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: variationKeys.detail(variationId || '', isAuthenticated),
    queryFn: async ({ signal }) => {
      if (!variationId) {
        return null;
      }
      return unwrap(
        await api.legacy.GET('/api/v1/variations/{variationId}', {
          params: { path: { variationId } },
          signal,
        })
      );
    },
    placeholderData: previousData => previousData,
    enabled: isAuthenticated && !!variationId,
    staleTime: 30000,
  });
}
